import { useEffect, useState } from "react";
import { Button, Link, Skeleton } from "@mui/material";
import { BreadcrumbsWidget, DataTableWrap } from "components";
import { useParams } from "react-router-dom";
import { useKategoriAramaMutation } from "api/search";
import SearchBar from "./SearchBar";

const ProductsPage = () => {
  const [KategoriArama, categories] = useKategoriAramaMutation();
  const { id } = useParams();
  const Id = parseInt(id);
  const [activeItem, setActiveItem] = useState("Ürünler");

  const columns = [
    {
      name: "Kategori",
      cell: (row) => {
        return (
          <>
            {row.sub > 0 ? (
              <Link underline="hover" href={`/products/${row.id}`}>
                {row.title}
              </Link>
            ) : (
              <Link underline="hover" color="secondary">
                {row.title}
              </Link>
            )}
          </>
        );
      },
      sortable: true,
    },
    {
      name: "Üst Kategori",
      cell: (row) => {
        return (
          <>
            {row.parantcategory.title ? (
              <Link
                underline="hover"
                href={`/products/${row.parantcategory.id}`}
              >
                {row.parantcategory.title}
              </Link>
            ) : (
              <Link underline="hover" color="secondary">
                {row.parantcategory.title}
              </Link>
            )}
          </>
        );
      },
      sortable: true,
    },
    {
      right: true,
      cell: (row) => {
        return (
          <Button variant="outlined" href={`/get-products/${row.id}`}>
            Ürünler
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    KategoriArama({ ust_id: Id });
  }, [KategoriArama, Id]);

  useEffect(() => {
    if (Id > 0) {
      if (categories.isSuccess) {
        const activeCat = categories.data.find(
          (x) => x.parantcategory.id === Id
        );
        setActiveItem(activeCat.parantcategory.title ?? false);
      }
    }
  }, [categories, Id]);

  return (
    <div className="w-full my-6">
      <div className="w-full h-auto container mx-auto">
        {categories.isLoading ? (
          <Skeleton height={340} />
        ) : (
          <>
            <div className="w-full mb-6">
              <BreadcrumbsWidget
                data={
                  Id !== 0 ? [{ title: "Ürünler", url: `/products/0` }] : false
                }
                activeItem={activeItem}
              />
              <SearchBar Arama={KategoriArama} data={categories} id={Id} />
            </div>
            <div className="w-full h-auto flex flex-col p-5 gap-4 border shadow bg-white">
              <div className="w-full h-auto block">
                <DataTableWrap
                  title="Ürün Kategorileri"
                  columns={columns}
                  initialData={categories.data}
                  deleteRow={false}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductsPage;
